import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialogModel } from '../../common/interfaces/IDialogModel.interface';
import { TranslationService } from '../../common/services/translation.service';

@Component({
    selector: 'cpq-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IDialogModel,
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>) { }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
    if (!this.data.title) {
      this.data.title = 'Admin.Msg.ConfirmButton';
    }
    if (!this.data.yesMsg) {
      this.data.yesMsg = 'Msg.Yes';
    }

  }
}
